export const modes = ["overview", "macro", "derma"] as const;

export type Mode = typeof modes[number];

/** Read a mode from the URL, falling back to "derma" when missing or unknown */
export function parseMode(value: string | null): Mode {
  return modes.find((m) => m === value) ?? "derma";
}
